<div style="height: 800px">
  <div id="adminDashboard" style="height: 100%"></div>
</div>
